import styled from 'styled-components'

export const Group = styled.div`
  display: flex;
  flex-direction: row;
`
